<div class="auth-page-container">
    <div class="auth-card">
      <div class="auth-icon">
        <i class="ri-lock-password-line"></i>
      </div>
      <h2 class="auth-title">Mot de passe oublié</h2>
  
      <p class="welcome-text">
        Renseigne ton e-mail pour recevoir un lien de réinitialisation 🔐
      </p>
  
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="auth-form">
        <div class="form-group">
          <label>Adresse e-mail</label>
          <input
            type="email"
            class="form-control"
            placeholder="ex : user@example.com"
            formControlName="email"
          />
          <div *ngIf="form.get('email')?.invalid && form.get('email')?.touched" class="text-danger small mt-1">
            Veuillez entrer une adresse e-mail valide.
          </div>
        </div>
  
        <button type="submit" class="btn btn-primary w-100 mt-2" [disabled]="form.invalid">
          Envoyer le lien
        </button>
  
        <p *ngIf="success" class="text-success mt-3 text-center">
          ✅ Un lien de réinitialisation a été envoyé à votre adresse e-mail.
        </p>
        <p *ngIf="error" class="text-danger mt-3 text-center">
          ❌ {{ error }}
        </p>
      </form>
  
      <div class="text-center mt-3">
        <a routerLink="/sign-in" class="forgot-link">← Retour à la connexion</a>
      </div>
    </div>
  </div>
  